<template>
  <div>
    <vs-popup :title="titleSideBar" :active.sync="modalForm"> </vs-popup>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row" v-if="this.dados.nome">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
            @input="alterarStatus"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nome"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="resetForm"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idUsuario == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import * as lang from 'vuejs-datepicker/src/locale';
import BotaoSubmit from '../../components/BotaoSubmit';
import service from '../../services';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    title: {
      type: String,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  data() {
    return {
      data: {},
      status: null,
      isUpdate: false,
      aguardeCadastro: false,
      idEmpresa: null,
      idUsuario: null,
      hasPermission: false,
      idClasse: null,
      languages: lang,
      funcoesValicao: null,
      dadosSideBar: {},
      modalForm: false,
      idClass: null,
      controllerGeral: 'classe',
      formCadastro: {
        status: true,
        nome: '',
      },
      isMobile: true,
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idClasse) {
        this.data = this.dados;
        this.isUpdate = true;
        this.idClasse = this.data.idClasse;
        this.formCadastro.nome = this.data.nome;
        this.formCadastro.status = !this.data.deletedAt;
        return;
      }
      this.isUpdate = false;
      this.formCadastro.nome = '';
      this.formCadastro.status = true;
    },

    validateState(ref) {
      const validate =
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated);
      if (validate) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      const validate =
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated);
      if (validate) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    async onSubmit() {
      try {
        const { nome } = this.formCadastro;
        const { idClasse } = this.data;
        this.$vs.loading();
        if (this.isUpdate) {
          await service.put(`${this.controllerGeral}`, 'atualizarClasse', {
            nome,
            idClasse,
          });
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Update Classe salvo com sucesso',
            color: 'success',
          });
          this.$emit('cancel');
          this.$emit('criacaoConcluida');
          return;
        }
        await service.post(`${this.controllerGeral}`, 'criarClasse', { nome });
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Classe salva com sucesso',
          color: 'success',
        });
        this.$emit('cancel');
        this.$emit('criacaoConcluida');
        return;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao Salvar Classe',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async alterarStatus() {
      if (this.isUpdate) {
        this.status = this.formCadastro.status;
        if (!this.status) {
          await this.deleteSubTipo();
          return;
        }
        await this.activeSubTipo();
        return;
      }
      this.status = this.formCadastro.status;
    },

    async activeSubTipo() {
      try {
        this.$vs.loading();
        await service.post(
          `${this.controllerGeral}`,
          `ativar-classe/${this.idClasse}`,
          {},
        );
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Classe ativa com sucesso',
          color: 'success',
        });
        this.$emit('criacaoConcluida');
        return;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao ativar Classe',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async deleteSubTipo() {
      try {
        this.$vs.loading();
        await service.delete(
          `${this.controllerGeral}`,
          `excluirClasse/${this.idClasse}`,
        );
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Classe deletada com sucesso',
          color: 'success',
        });
        this.$emit('criacaoConcluida');
        return;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao deletar Classe',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    resetForm() {
      this.formCadastro = {
        status: true,
        nome: '',
      };
      this.data = Object.assign({}, this.dados);
      this.$validator.reset();
      this.$emit('cancel');
    },
  },
  components: {
    BotaoSubmit,
  },
  mounted() {
    this.$on('fecharPainel', () => {
      this.resetForm();
    });
  },
};
</script>
